import { customCompareDates } from './dateUtils';
import { NOTIFICATION_ACTIONS } from '../constants/NotificationConstants';

export const preprocessNotifications = (notifications) =>
  notifications.map(({ Notification, NotificationUserAction }) => ({
    id: Notification.Id,
    text: Notification.Text,
    origin: Notification.Origin,
    expiresInDays: Notification.ExpiresInDays,
    createdDate: Notification.CreatedDate,
    createdBy: Notification.CreatedBy,
    title: Notification.Title,
    notificationExtensions: Notification.ExtensionObj || {},
    action: NotificationUserAction?.Action || NOTIFICATION_ACTIONS.UNREAD,
  }));

export const sortNotificationsByDate = (notifications) =>
  notifications.sort((a, b) => customCompareDates(a?.createdDate, b?.createdDate, 'desc'));
